import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

// Reducers
import { configReducer } from "redux/ducks/config";
import { changePasswordReducer } from "redux/ducks/changePassword";
import configSyncReducer from "../reducers/configSync/configSyncReducer";
import { unitsSectionReducer } from "redux/ducks/unitsSection";
import { brandsSectionReducer } from "redux/ducks/brandsSection";
import { crmReducer } from "redux/reducers/crmReducer";
import { dispensersReducer } from "redux/ducks/dispensers";
import { giotanksReducer } from "redux/ducks/giotanks";
import { giotanksGraphReducer } from "redux/ducks/giotanksGraph";
import { globalSnackbarReducer } from "redux/ducks/globalSnackbar";
import { pricesBusinessReducer } from "redux/ducks/pricesBusinessSection";
import { pricesSectionReducer } from "redux/ducks/pricesSection";
import { profitStationReducer } from "redux/ducks/profitStation";
import { updatePriceReducer } from "redux/ducks/updatePrice";
import { mapPageReducer } from "redux/ducks/mapPage";
import { loginReducer } from "./login/loginReducer";
import { resetPasswordReducer } from "redux/ducks/resetPassword";
import { ordersHistoryReducer } from "redux/ducks/ordersHistory";
import { ordersGraphReducer } from "redux/ducks/ordersGraph";
import { pipesSeriesReducer } from "redux/ducks/pipesSeries";

//buildings
import { buildingsReducers } from "./buildings";

// news
import { newBrandReducer } from "../ducks/newBrand";
import { newBrandSaleReducer } from "../ducks/newBrandSale";
import { newBrandStationReducer } from "../ducks/newBrandStation";
import { expensesReducer } from "../ducks/expenses";
import { tanksReducer } from "./tanks/tanksReducer";
import { companiesReducer } from "./companies/companiesReducer";
import { tagsReducer } from "./tags/tagsReducer";
import { brandsReducerV2 } from "./brands/brandsReducer";
import { schedulesReducer } from "./schedule/schedulesReducer";
import { errorReducer } from "./errorsReducer";
import { unitsReducerV2 } from "./units_v2/unitsReducer";
import { productsReducer } from "./products/productsReducer";
import { notesReducer } from "./notes/notesReducer";
import { liquidationsReducer } from "./liquidations/liquidationsReducer";
import { gasMovementsReducer } from "./gasMovements/gasMovementsReducer";
import { productsCatalogReducer } from "./productsCatalog/productsCatalogReducer";
import { warehousesCatalogReducer } from "./warehousesCatalog/warehousesCatalogReducer";
import { routesStatusReducer } from "./routesStatus/routesStatusReducer";
import { volumetricsInvReducer } from "./volumetricsInventory/volumetricInvReducer";
import { surveysReducer } from "./surveys/surveysReducer";
import { invoicesReducer } from "./invoices/invoicesReducer";
import { carburationReducer } from "./carburetions/carburationReducer";
import { contractsCatalogReducer } from "./contractsCatalog/contractsCatalogReducer";
import { contractsConditionsCatalogReducer } from "./contractsConditionsCatalog/contractsConditionsCatalogReducer";
import { employeesCatalogReducer } from "./employeesCatalog/employeesCatalogReducer";
import { searchReducer } from "./search/searchReducer";
import { inventoriesReducer } from "./inventories/inventoryReducer";
import { conditionsReducer } from "./conditionsCatalog/conditioinsReducer";
import { shipperTrucksReducer } from "./shipperTrucks/shipperTrucksReducer";
import { purchasesReducer } from "./purchases/purchasesReducer";

import { customersReducer } from "./customers/customersReducer";
import { itemsReducer } from "./integrations/itemsReducer";
import { itemsRequestsReducer } from "./integrations/itemsRequestsReducer";
import { categoriesReducer } from "./categories/categoriesReducer";
import { classesReducer } from "./classes/classesReducer";
import { companiesItemsReducer } from "./companies/companiesForItemsReducer";
import { formGeneratorReducer } from "./form-generator/formGeneratorReducer";
import { taxisReducer } from "./taxis/taxisReducer";
import { usersReducer } from "./users/usersReducer";
import { printersReducer } from "./printers/printersReducer";
import { supplyNotesReducer } from "./supplyNotes/supplyNotesReducer";
import { notesFlotillaReducer } from "./notesFlotilla/notesFlotillaReducer";
// import { ordersReducer } from "redux/ducks/orders";
import { ordersReducer } from "./orders/ordersReducer";
import { xlsxReducer } from "./XLSX/xlsxReducer";
import { comoDataReducer } from "./comoData/comoDataReducer";
import { comoDataTanksReducer } from "./comoDataTanks/comoDataTanksReducer";
import { tabulatorsCatalogReducer } from "./tabulatorsCatalog/tabulatorsCatalogReducer";
import { prePayrollsReducer } from "./prePayroll/prePayrollReducer";
import { gasMovDataXLSXReducer } from "./gasMovDataXLSX/gasMovDataXLSXReducer";
import { couponsReducer } from "./coupons/couponsReducer";
import { stationSalesReducer } from "./stationSales/stationSalesReducer";
import { sgcConfigurationsReducer } from "./sgcConfigurations/sgcConfigurationsReducer";
import { configChangeReducer } from "./configChange/configChangeReducer";

import { stationMunicipalitiesReducer } from "./stationMunicipalities/stationMunicipalitiesReducer";
import { gasMovementsRequestsReducer } from "./gasMovementsRequests/gasMovementsRequestsReducer";
import { sgcReducer } from "./sgc/sgcReducer";
import { globalInvoicesReducer } from "./globalInvoices/globalInvoicesReducer";
import { globalInvoiceStatusReducer } from "./globalInvoiceStatus/globalInvoiceStatusReducer";
import { invoicesTransferReducer } from "./invoicesTransfer/invoicesTransferReducer";
import { nfcTagsReducer } from "./nfcTags/nfcTagsReducer";
import { dispenserUserReducer } from "./dispenserUser/dispenserUserReducer";
import { fillingOrderReducer } from "./fillingOrder/fillingOrderReducer";
import { notesMigrationReducer } from "./notesMigration/notesMigrationReducer";
import { notesFiscalUpdateReducer } from "./notesFiscalUpdate/notesFiscalUpdateReducer";
import { supervisionReducer } from "./supervision/supervisionReducer";
import { supervisedReducer } from "./supervision/supervisedReducer";
import { catalogsSyncReducer } from "./catalogsSync/catalogsSyncReducer";
import { depositsReducer } from "./deposits/depositsReducer";
import { reportDayReducer } from "./Reports/reportDay/reportDayReducer";
import { reportDigitalInventoryReducer } from "./Reports/reportDigitalInventory/reportDigitalInventoryReducer";
import { supportExpensesReducer } from "./supportExpenses/supportExpensesReducer";
import { reportSupervisionReducer } from "./Reports/reportSupervision/reportSupervisionReducer";
import { creditNotesReducer } from "./creditNotes/creditNotesReducer";
import { reportAdvancePaymentsReducer } from "./Reports/reportAdvancePayments/reportAdvancePaymentsReducer";
import { reportAuditSettlementsReducer } from "./Reports/reportAuditSettlements/reportAuditSettlementsReducer";
import { reportCarburetionReducer } from "./Reports/reportCarburetion/reportCarburetionReducer";
import { reportCarburetion3Reducer } from "./Reports/reportCarburetion3/reportCarburetion3Reducer";
import { reportInventoriesReducer } from "./Reports/reportInventories/reportInventoriesReducer";
import { reportInventoryStockReducer } from "./Reports/reportInventoryStock/reportInventoryStockReducer";
import { reportGasMovementsReducer } from "./Reports/reportGasMovements/reportGasMovementsReducer";
import { reportSalesReducer } from "./Reports/reportSales/reportSalesReducer";
import { reportCreditReducer } from "./Reports/reportCredit/reportCreditReducer";
import { reportNotesTransferredReducer } from "./Reports/reportNotesTransferred/reportNotesTransferredReducer";
import { reportCorporateShipmentsReducer } from "./Reports/reportCorporateShipments/reportCorporateShipmentsReducer";
import { reportProgressiveAppReducer } from "./Reports/reportProgressiveApp/reportProgressiveAppReducer";
import { reportShipmentsPerformanceReducer } from "./Reports/reportShipmentsPerformance/reportShipmentsPerformanceReducer";
import { reportSubstitutionSettlementsReducer } from "./Reports/reportSubstitutionSettlements/reportSubstitutionSettlementsReducer";
import { reportSettlementsReducer } from "./Reports/reportSettlements/reportSettlementsReducer";
import { reportCashDiscountCustomersReducer } from "./Reports/reportCashDiscountCustomers/reportCashDiscountCustomersReducer";
import { reportRetentionsReducer } from "./Reports/reportRetentions/reportRetentionsReducer";
import { reportRetentionsExistsReducer } from "./Reports/reportRetentionsExists/reportRetentionsExistsReducer";
import { reportUnitPerformanceReducer } from "./Reports/reportUnitPerformance/reportUnitPerformanceReducer";
import { reportUnitsWithPermissionReducer } from "./Reports/reportUnitsWithPermission/reportUnitsWithPermissionReducer";
import { reportAccumulatedDiscountReducer } from "./Reports/reportAccumulatedDiscount/reportAccumulatedDiscountReducer";
import { reportSpecialUnitsReducer } from "./Reports/reportSpecialUnits/reportSpecialUnitsReducer";
import { reportCashReconciliationReducer } from "./Reports/reportCashReconciliation/reportCashReconciliationReducer";
import { reportResumeDayReducer } from "./Reports/reportResumeDay/reportResumeDayReducer";
import { reportSalesCustomerReducer } from "./Reports/reportSalesCustomer/reportSalesCustomerReducer";
import { reportSalesCategoryReducer } from "./Reports/reportSalesCategory/reportSalesCategoryReducer";
import { reportSaleByMunicipalityReducer } from "./Reports/reportSaleByMunicipality/reportSaleByMunicipalityReducer";
import { reportSalesByZoneWholesalerReducer } from "./Reports/reportSalesByZoneWholesaler/reportSalesByZoneWholesalerReducer";
import { coveragesReducer } from "./coverages/coveragesReducer";
import { coveragesAssignReducer } from "./coveragesAssign/coveragesAssignReducer";
import { coverageGroupsReducer } from "./coverageGroups/coverageGroupsReducer";
import { reportSalesByNoteReducer } from "./Reports/reportSalesByNote/reportSalesByNoteReducer";
import { reportComoDataReducer } from "./Reports/reportComoData/reportComoDataReducer";
import { reportGlobalSalesReducer } from "./Reports/reportGlobalSales/reportGlobalSalesReducer";
import { invoicesCashReducer } from "./invoices/invoicesCashReducer";
import { reportDepositsReducer } from "./Reports/reportDeposits/reportDepositsReducer";
import { creditsUnlockReducer } from "./creditsUnlock/creditsUnlockReducer";
import { reportInvoiceListReducer } from "./Reports/reportInvoiceList/reportInvoiceListReducer";
import { reportInvoiceRelationshipReducer } from "./Reports/reportInvoiceRelationship/reportInvoiceRelationshipReducer";
import { reportTransferInvoiceReducer } from "./Reports/reportTransferInvoice/reportTransferInvoiceReducer";
import { reportDetailedNotesReducer } from "./Reports/reportDetailedNotes/reportDetailedNotesReducer";
import { reportDiscountsRelationshipReducer } from "./Reports/reportDiscountsRelationship/reportDiscountsRelationshipReducer";
import { reportNationalNotesReducer } from "./Reports/reportNationalNotes/reportNationalNotesReducer";
import { inventoryDigitalMovementsReducer } from "./inventoryDigitalMovements/inventoryDigitalMovementsReducer";
import { reportSalesCumulativeGlobalReducer } from "./Reports/reportSalesCumulativeGlobal/reportSalesCumulativeGlobalReducer";
import { inventoryStatusReducer } from "./inventoryStatus/inventoryStatusReducer";
import { stationConfigurationsReducer } from "./stationConfigurations/stationConfigurationsReducer";
import { tanksReducer2 } from "./tanks/tanksReducer_";
import { promocodesReducer } from './promocode/promocodeReducer'
import { erpEquivalenciesReducer } from "./erpEquivalencies/erpEquivalenciesReducer";
import { warehousesGraphsReducer } from "./warehousesGraphs/warehousesGraphsReducer";
import { wholesalerRetentionsReducer } from "./wholesalerRetentions/wholesalerRetentionsReducer";
import { specialUnitsReducer } from "./specialUnits/specialUnitsReducer";
import { retentionOutputsReducer } from "./retentionOutputs/retentionOutputsReducer";
import { monthlyClosingReducer } from "./monthlyClosing/monthlyClosingReducer";

import { reportShipmentsReturnsReducer } from "./Reports/reportShipmentsReturns/reportShipmentsReturnsReducer";
import { reportInventoryPercentagesReducer } from "./Reports/reportInventoryPercentages/reportInventoryPercentagesReducer";
import { reportInvoicesGroupedReducer } from "./Reports/reportInvoicesGrouped/reportInvoicesGroupedReducer";
import { issuesReducer } from "./issues/issuesReducer";
import { adminUnitsReducer } from "./adminUnits/adminUnitsReducer";
import { policyManagmentReducer } from "./policyManagment/policyManagmentReducer";
import { electronicEquipmentReducer } from "./electronicEquipment/electronicEquipmentReducer";


import { liquidationOtherProductsReducer } from "./liquidationOtherProducts/liquidationOtherProductsReducer";
import { accountingAccountReducer } from "./accountingAccount/accountingAccountReducer";
import { accountingAccountRelationReducer } from "./accountingAccountRelation/accountingAccountRelationReducer";
import { iotDevicesReducer } from "./iotDevices/iotDevicesReducer";


const createRootReducer = (history) => {
  // Objeto con todos los reducers
  const reducers = {
    router: connectRouter(history),
    config: configReducer,
    map: mapPageReducer,
    configSync: configSyncReducer,
    changePassword: changePasswordReducer,
    brandsSection: brandsSectionReducer,
    crm: crmReducer,
    customersReducer,
    items: itemsReducer,
    itemsRequests: itemsRequestsReducer,
    categories: categoriesReducer,
    classes: classesReducer,
    dispensers: dispensersReducer,
    giotanks: giotanksReducer,
    giotanksGraph: giotanksGraphReducer,
    globalSnackbar: globalSnackbarReducer,
    pricesSection: pricesSectionReducer,
    pricesBusiness: pricesBusinessReducer,
    profitStation: profitStationReducer,
    unitsSection: unitsSectionReducer,
    users: usersReducer,
    updatePrice: updatePriceReducer,
    login: loginReducer,
    resetPassword: resetPasswordReducer,
    //buildings
    ...buildingsReducers,
    // ,
    orders: ordersReducer,
    coupons: couponsReducer,
    promocodes: promocodesReducer,
    ordersHistory: ordersHistoryReducer,
    ordersGraph: ordersGraphReducer,
    pipesSeries: pipesSeriesReducer,
    newBrand: newBrandReducer,
    newBrandSale: newBrandSaleReducer,
    newBrandStation: newBrandStationReducer,
    expenses: expensesReducer,
    tanks: tanksReducer,
    tanks2: tanksReducer2,
    notes: notesReducer,
    volumetricInv: volumetricsInvReducer,
    liquidations: liquidationsReducer,
    supervision: supervisionReducer,
    supervised: supervisedReducer,
    gasMovements: gasMovementsReducer,
    productsCatalog: productsCatalogReducer,
    warehousesCatalog: warehousesCatalogReducer,
    routesStatus: routesStatusReducer,
    invoices: invoicesReducer,
    carburations: carburationReducer,
    contractsCatalog: contractsCatalogReducer,
    tabulatorsCatalog: tabulatorsCatalogReducer,
    prePayroll: prePayrollsReducer,
    contractsConditionsCatalog: contractsConditionsCatalogReducer,
    employeesCatalog: employeesCatalogReducer,
    search: searchReducer,
    PG: shipperTrucksReducer,
    purchases: purchasesReducer,
    companies: companiesReducer,
    companiesItems: companiesItemsReducer,
    tagsReducer: tagsReducer,
    brandsReducer: brandsReducerV2,
    schedulesReducer: schedulesReducer,
    globalErrors: errorReducer,
    unitsReducer: unitsReducerV2,
    productsReducer: productsReducer,
    surveys: surveysReducer,
    stationSales: stationSalesReducer,
    inventories: inventoriesReducer,
    conditionsReducer,
    formGeneratorReducer,
    taxis: taxisReducer,
    printers: printersReducer,
    supplyNotes: supplyNotesReducer,
    notesFlotilla: notesFlotillaReducer,
    comoData: comoDataReducer,
    comoDataTanks: comoDataTanksReducer,
    stationMun: stationMunicipalitiesReducer,
    sgcConfigurations: sgcConfigurationsReducer,
    configChange: configChangeReducer,
    gasMovementsRequests: gasMovementsRequestsReducer,
    xlsxReducer,
    gasMovDataXLSX: gasMovDataXLSXReducer,
    sgc: sgcReducer,
    globalInvoices: globalInvoicesReducer,
    globalInvoiceStatus: globalInvoiceStatusReducer,
    invoicesTransfer: invoicesTransferReducer,
    nfcTags: nfcTagsReducer,
    dispenserUser: dispenserUserReducer,
    fillingOrder: fillingOrderReducer,
    notesMigration: notesMigrationReducer,
    notesFiscalUpdate: notesFiscalUpdateReducer,
    catalogsSync: catalogsSyncReducer,
    deposits: depositsReducer,
    reportDay: reportDayReducer,
    supportExpenses: supportExpensesReducer,
    reportSupervision: reportSupervisionReducer,
    creditNotes: creditNotesReducer,
    reportAdvancePayments: reportAdvancePaymentsReducer,
    reportAuditSettlements: reportAuditSettlementsReducer,
    reportInventories: reportInventoriesReducer,
    reportInventoryStock: reportInventoryStockReducer,
    reportGasMovements: reportGasMovementsReducer,
    reportCarburetion: reportCarburetionReducer,
    reportDetailedNotes: reportDetailedNotesReducer,
    reportCarburetion3: reportCarburetion3Reducer,
    reportDigitalInventory: reportDigitalInventoryReducer,
    reportDiscountsRelationship: reportDiscountsRelationshipReducer,
    reportCashReconciliation: reportCashReconciliationReducer,
    reportProgressiveApp: reportProgressiveAppReducer,
    reportSales: reportSalesReducer,
    reportSalesCustomer: reportSalesCustomerReducer,
    reportSalesCumulativeGlobal: reportSalesCumulativeGlobalReducer,
    reportSaleByMunicipality: reportSaleByMunicipalityReducer,
    reportSalesByNote: reportSalesByNoteReducer,
    reportSalesByZoneWholesaler: reportSalesByZoneWholesalerReducer,
    reportCredit: reportCreditReducer,
    reportNotesTransferred: reportNotesTransferredReducer,
    reportCorporateShipments: reportCorporateShipmentsReducer,
    reportShipmentsPerformance: reportShipmentsPerformanceReducer,
    reportSubstitutionSettlements: reportSubstitutionSettlementsReducer,
    reportSettlements: reportSettlementsReducer,
    reportCashDiscountCustomers: reportCashDiscountCustomersReducer,
    reportRetentions: reportRetentionsReducer,
    reportRetentionsExists: reportRetentionsExistsReducer,
    reportSpecialUnits: reportSpecialUnitsReducer,
    reportUnitPerformance: reportUnitPerformanceReducer,
    reportUnitsWithPermission: reportUnitsWithPermissionReducer,
    reportAccumulatedDiscount: reportAccumulatedDiscountReducer,
    reportResumeDay: reportResumeDayReducer,
    reportDeposits: reportDepositsReducer,
    reportSalesCategory: reportSalesCategoryReducer,
    coverages: coveragesReducer,
    coveragesAssign: coveragesAssignReducer,
    coverageGroups: coverageGroupsReducer,
    reportComoData: reportComoDataReducer,
    cashInvoices: invoicesCashReducer,
    reportInvoiceList: reportInvoiceListReducer,
    reportInvoiceRelationship: reportInvoiceRelationshipReducer,
    reportTransferInvoice: reportTransferInvoiceReducer,
    creditsUnlock: creditsUnlockReducer,
    reportGlobalSales: reportGlobalSalesReducer,
    reportNationalNotes: reportNationalNotesReducer,
    reportShipmentsReturns: reportShipmentsReturnsReducer,
    reportInventoryPercentages: reportInventoryPercentagesReducer,
    reportInvoicesGrouped: reportInvoicesGroupedReducer,
    issues: issuesReducer,
    inventoriesDigitalMovements: inventoryDigitalMovementsReducer,
    inventoryStatus: inventoryStatusReducer,
    stationConfig: stationConfigurationsReducer,
    adminUnits: adminUnitsReducer,
    policyManagment: policyManagmentReducer,
    erpEquivalencies: erpEquivalenciesReducer,
    electronicEquipment: electronicEquipmentReducer,
    warehousesGraphs: warehousesGraphsReducer,
    liquidationOtherProducts: liquidationOtherProductsReducer,
    wholesalerRetentions: wholesalerRetentionsReducer,
    retentionOutputs: retentionOutputsReducer,
    monthlyClosing: monthlyClosingReducer,
    specialUnits: specialUnitsReducer,
    accountingAccount: accountingAccountReducer,
    accountingAccountRelation: accountingAccountRelationReducer,
    iotDevices: iotDevicesReducer,
  };

  const sortedKeys = Object.keys(reducers).sort();

  const sortedReducers = sortedKeys.reduce((acc, key) => {
    acc[key] = reducers[key];
    return acc;
  }, {});

  const appReducer = combineReducers(sortedReducers);

  const rootReducer = (state, action) => {
    if (action.type === "CLOSE_SESSION_LOGIN")
      return appReducer(undefined, action);

    return appReducer(state, action);
  };

  return rootReducer;
};

export default createRootReducer;
